import { format } from 'date-fns';

function safeDate(value: string): Date | null {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed;
}

const TABLE_REGISTERED_FORMAT = 'MMM d, yyyy';

/** Table column: registered date. */
export function formatTableRegistered(iso: string | null): string {
  if (iso == null || iso === '') return '—';
  const d = safeDate(iso);
  if (!d) return '—';
  return format(d, TABLE_REGISTERED_FORMAT);
}
